export enum orderStatus {
    NEW = 'new',
    CONFIRMED = 'confirmed',
    KITCHEN = 'kitchen',
    IN_DELIVERY = 'in_delivery',
    DELIVERED = 'delivered',
    CANCELLED = 'cancelled'
}
